import {
  setConsent,
  getAnalytics,
  setAnalyticsCollectionEnabled,
} from 'firebase/analytics';
import { firebaseAnalyticsEnabledConsentSettings } from 'src/utils/firebase/consentSettings';
import { firebaseApp } from 'src/utils/firebase';

const analytics = getAnalytics(firebaseApp);

// We use this function to enable or disable google analytics auto tracking,
// manual tracking and cookies.
// Note: Firebase is initialized outside the scope of react and is initialized
// when the 'src/utils/firebase' is imported from somewhere. In this file we
// import 'src/utils/firebase' anyway so we can guarantee firebase has already
// initialized. We should ideally refactor so that firebase is controlled by the
// react lifecycle.
export const enableGoogleAnalytics = (): void => {
  setConsent(firebaseAnalyticsEnabledConsentSettings);
  firebaseApp.automaticDataCollectionEnabled = true;
  setAnalyticsCollectionEnabled(analytics, true);
};
